import { openModal } from 'components/Modal';
import { connect } from 'react-redux';
import SelectInstructorInput from './SelectInstructorInput';

const mapDispatchToProps = {
  onAddInstructorClick: openModal.bind(null, 'AddScheduleInstructorModal'),
};

export default connect(null, mapDispatchToProps)(SelectInstructorInput);
